<template>
  <div class="div-dropdown side-by-side">
    <Dropdown
      title="Opções"
      type="primary"
      size="small"
      classIcon="fa-solid fa-chevron-down"
      right="50"
      :items="optionsConditional"
      :param="dropdownParam"
    />

    <Modal
      title="Tem certeza que deseja excluir?"
      :width="500"
      v-show="showModal('deleteNfse')"
    >
      <Confirmation
        :isModal="false"
        title="Deseja excluir?"
        type="danger"
        :confirmed="remove"
      />
    </Modal>

    <Modal
      title="Tem certeza que deseja cancelar?"
      :width="500"
      v-show="showModal('cancelNfse')"
    >
      <Confirmation
        :isModal="false"
        title="Deseja cancelar?"
        type="danger"
        :confirmed="cancel"
      />
    </Modal>

    <Modal
      title="Tem certeza que deseja gerar?"
      :width="500"
      v-show="showModal('generateNfse')"
    >
      <div class="text-center">
        <Button
          _key="btnGenerate"
          title="Confirmar"
          size="medium"
          type="primary"
          :clicked="generate"
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Dropdown from "@nixweb/nixloc-ui/src/component/forms/Dropdown.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Confirmation from "@nixweb/nixloc-ui/src/component/shared/Confirmation.vue";

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "NfseDropdownOptions",
  props: {
    status: {
      type: Number,
      default: 0,
    },
    urlReceita: {
      type: String,
      default: "",
    },
    urlPdf: {
      type: String,
      default: "",
    },
    urlXml: {
      type: String,
      default: "",
    },
    source: {
      type: String,
      required: true,
    },
    locacaoId: {
      type: String,
      default: "",
    },
    rent: {
      type: Object,
      default: null,
    },
    documentId: {
      type: String,
      default: "",
    },
    contextItem: {
      type: Object,
      default: null,
    },
    editRouteName: {
      type: String,
      default: "",
    },
    onlyFileAndEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button,
    Dropdown,
    Modal,
    Select,
    Confirmation,
    Alert,
  },
  data() {
    return {
      id: this.$route.params.id,
      urlGetAllSharedApi: "/api/v1/tax-document/nfse-shared",
      nfseSharedList: [],
      options: [
        {
          showByStatus: [5],
          title: "Atualizar",
          classIcon: "fa-solid fa-arrows-rotate",
          eventName: "updateNfse",
          style: "color:#4BB3E1;",
        },
        {
          showByStatus: [3, 6, 7],
          title: "Gerar",
          classIcon: "fa-solid fa-retweet",
          eventName: "generateNfse",
          style: "color:#007BFF;",
        },
        {
          showByStatus: [1, 2, 4],
          title: "Baixar PDF",
          classIcon: "fa-solid fa-file-pdf",
          eventName: "getPdfNfse",
        },
        {
          showByStatus: [1, 2, 4],
          title: "Baixar XML",
          classIcon: "fa-solid fa-memo-pad",
          eventName: "getXmlNfse",
          hr: true,
        },
        {
          showByStatus: [1, 2, 4],
          title: "Visualizar no Site",
          classIcon: "fa-solid fa-eye",
          eventName: "getReceitaNfse",
          hr: true,
        },
        {
          showByStatus: [3, 6],
          key: "delete",
          title: "Excluir",
          classIcon: "fa-solid fa-trash",
          style: "color:red;",
          eventName: "deleteNfse",
        },
        {
          showByStatus: [1, 2],
          key: "cancel",
          title: "Cancelar",
          classIcon: "fa-solid fa-ban",
          style: "color:red;",
          eventName: "cancelNfse",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapGetters("user", ["hasRule"]),
    apiPath() {
      return `/api/v1/tax-document/${this.source}`;
    },
    dropdownParam() {
      return this.contextItem || null;
    },
    currentLocacaoId() {
      return (
        this.rent?.id || this.locacaoId || this.$route?.params?.rentId || ""
      );
    },
    normalizedNfseSharedList() {
      return (this.nfseSharedList || []).map((item) => ({
        id: item.id || item.Id || "",
        cliente: item.cliente || item.Cliente || "",
        numero: item.numero || item.Numero || "",
        status: item.status || item.Status || 0,
        statusNome: item.statusNome || item.StatusNome || "",
        registeredDate: item.registeredDate || item.RegisteredDate || "",
        valorNota: item.valorNota || item.ValorNota || 0,
        locacaoId: item.locacaoId || item.LocacaoId || "",
        urlPdf: item.urlPdf || item.UrlPdf || "",
        urlXml: item.urlXml || item.UrlXml || "",
      }));
    },
    currentNfseShared() {
      if (this.contextItem) {
        return {
          id:
            this.contextItem.id || this.contextItem.Id || this.documentId || "",
          status:
            this.contextItem.status ||
            this.contextItem.Status ||
            this.status ||
            0,
          urlPdf:
            this.contextItem.urlPdf ||
            this.contextItem.UrlPdf ||
            this.urlPdf ||
            "",
          urlXml:
            this.contextItem.urlXml ||
            this.contextItem.UrlXml ||
            this.urlXml ||
            "",
        };
      }

      if (!this.normalizedNfseSharedList.length) return null;

      const byId = this.normalizedNfseSharedList.find((x) => x.id === this.id);
      if (byId) return byId;

      return this.normalizedNfseSharedList[0];
    },
    currentUrlPdf() {
      return this.currentNfseShared?.urlPdf || this.urlPdf;
    },
    currentUrlXml() {
      return this.currentNfseShared?.urlXml || this.urlXml;
    },
    currentStatus() {
      return this.currentNfseShared?.status || this.status;
    },
    currentEditId() {
      return this.documentId || this.currentNfseShared?.id || this.id;
    },
    resolvedEditRouteName() {
      if (this.editRouteName) return this.editRouteName;
      if (this.source === "nfse-nacional") return "nfseNacionalUpdate";
      if (this.source === "nfse-prefeitura") return "nfsePrefeituraUpdate";
      return "nfseUpdate";
    },
    optionsConditional() {
      let options = [];
      this.options.forEach((option) => {
        if (!option.showByStatus.includes(this.currentStatus)) return;
        if (
          this.onlyFileAndEdit &&
          !["getPdfNfse", "getXmlNfse"].includes(option.eventName)
        )
          return;
        if (
          this.source === "nfse-prefeitura" &&
          option.eventName === "getReceitaNfse"
        )
          return;
        if (option.eventName === "editNfse" && !this.hasRule("TaxDocument"))
          return;
        options.push(option);
      });
      return options;
    },
  },
  mounted() {
    if (!this.contextItem) {
      this.getAllShared();
    }
  },
  methods: {
    ...mapMutations("generic", [
      "addEvent",
      "openModal",
      "hideModal",
      "removeLoading",
    ]),
    ...mapActions("generic", ["getApi", "putApi", "deleteAllApi"]),
    getAllShared() {
      if (!this.currentLocacaoId) return;

      const params = {
        url: this.urlGetAllSharedApi,
        obj: {
          locacaoId: this.currentLocacaoId,
          noPaginated: true,
        },
        notNotifyToast: true,
      };

      this.getApi(params).then((response) => {
        const content = response?.content;
        if (Array.isArray(content)) {
          this.nfseSharedList = content;
          return;
        }

        this.nfseSharedList = content?.data || [];
      });
    },
    getPdf() {
      if (this.currentUrlPdf) {
        const a = document.createElement("a");
        a.href = this.currentUrlPdf;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    getXml() {
      if (this.currentUrlXml) {
        const a = document.createElement("a");
        a.href = this.currentUrlXml;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    getReceita() {
      if (this.urlReceita) {
        window.open(this.urlReceita, "_blank");
      }
    },
    edit() {
      if (!this.hasRule("TaxDocument") || !this.currentEditId) return;

      this.$router.push({
        name: this.resolvedEditRouteName,
        params: { id: this.currentEditId },
      });
    },
    isEventForCurrentItem(event) {
      if (!event?.data || !this.currentEditId) return true;

      const eventId = event.data.id || event.data.Id;
      if (!eventId) return true;

      return eventId === this.currentEditId;
    },
    generate() {
      let params = {
        url: `${this.apiPath}/generate`,
        obj: { id: this.id },
        notNotifyToast: true,
      };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "refreshNfse" });
          this.hideModal("generateNfse");
        }
        this.removeLoading(["btnGenerate"]);
      });
    },
    remove() {
      let params = {
        url: `${this.apiPath}/delete`,
        selected: [this.id],
      };
      this.deleteAllApi(params).then((response) => {
        if (response.success) {
          this.$router.push({ name: "nfseList" });
          this.hideModal("deleteNfse");
        }
        this.removeLoading(["confirm"]);
      });
    },
    cancel() {
      let params = {
        url: `${this.apiPath}/cancel`,
        selected: [this.id],
      };
      this.deleteAllApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "refreshNfse" });
          this.hideModal("cancelNfse");
        }
        this.removeLoading(["confirm"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (!this.isEventForCurrentItem(event)) return;

        if (event.name === "getPdfNfse") {
          this.getPdf();
        }

        if (event.name === "getXmlNfse") {
          this.getXml();
        }

        if (event.name === "getReceitaNfse") {
          this.getReceita();
        }

        if (event.name === "editNfse") {
          this.edit();
        }

        if (event.name === "generateNfse") {
          this.openModal("generateNfse");
        }

        if (event.name === "deleteNfse") {
          this.openModal("deleteNfse");
        }

        if (event.name === "cancelNfse") {
          this.openModal("cancelNfse");
        }

        if (event.name === "refreshNfse") {
          this.getAllShared();
        }
      },
      deep: true,
    },
    currentLocacaoId() {
      if (!this.contextItem) {
        this.getAllShared();
      }
    },
  },
};
</script>

<style scoped>
.div-dropdown {
  margin-left: 8px;
}
</style>
